import { Type } from 'class-transformer';
import { ArtstammScan } from './ArtstammScan';

export class ScanArtikelResult {
    @Type(() => ArtstammScan)
    public artstammScan: ArtstammScan;
    public warnmeldung: string;
    public endetikett: boolean;
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/data/ScanArtikelResult.ts